import { Observable } from 'rxjs/Observable'

import { CreateByTypeStrategy, BaseModel, CreateDefaultStrategy } from '../../'
import { Utils, AppInjector } from '../../helpers'

export class EntityAbstractFactory {
  private _createByTypeRegistry: Map<string, CreateByTypeStrategy> = new Map<string, CreateByTypeStrategy>()

  constructor(
    _factoryStrategyClasses: Array<{new(): any}>,
    private _createDefaultStrategy: CreateDefaultStrategy,
    _appInjector: AppInjector,
    private _utils: Utils,
  ) {
    _factoryStrategyClasses.forEach((strategyClass) => {
      const strategy = _appInjector.get(strategyClass)
      if (typeof strategy.createByType === 'function') {
        this._createByTypeRegistry.set(this._utils.pascalCase(strategy.registrationType), strategy)
      }
    })
  }

  public create(modelType: string): BaseModel {
    return this._createDefaultStrategy.create(modelType)
  }

  public createByType(modelType: string, byTypeId: string): Observable<BaseModel> {
    const normalizedModelType = this._utils.pascalCase(modelType)
    const strategy = this._createByTypeRegistry.get(normalizedModelType)

    if (! strategy) {
      throw Error(`there is no creation strategy registered for ${normalizedModelType}`)
    }

    return strategy.createByType(byTypeId)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/factories/entity-abstract-factory/entity.abstract-factory.ts